export const isChitNetAmountInvalid = (netamount) => {
  const netNum = Number(netamount);
  return (
    netamount === "" ||
    netamount === null ||
    netamount === undefined ||
    !Number.isFinite(netNum) ||
    netNum === 0
  );
};

const isChitDateInvalid = (date) =>
  !date ||
  (date instanceof Date && Number.isNaN(date.getTime()));

export const getChitValidationErrors = ({
  type,
  list = [],
  unAllocated,
  matterref,
  matterrefTo,
  dateselector,
  payee,
  payer,
  netamount,
  vatvalue,
  feeearnerref,
  comboBoxesInfo = [],
  branchValue,
  details,
}) => {
  const errors = {
    postingType: !type?.code,
    matter:
      (list.includes("MatterID") || list.includes("MatterIDFrom")) &&
      !unAllocated &&
      !matterref,
    matterTo: list.includes("MatterIDFrom") && !matterrefTo,
    date: isChitDateInvalid(dateselector),
    payee:
      list.includes("Payee") && !String(payee ?? "").trim(),
    payer:
      list.includes("Payer") && !String(payer ?? "").trim(),
    netAmount:
      list.includes("NetAmount") && isChitNetAmountInvalid(netamount),
    vatCode: list.includes("VatCode") && vatvalue == null,
    feeEarner:
      list.includes("FeeEarnerRef") && !feeearnerref,
    branch:
      list.includes("BranchId") &&
      (!branchValue || branchValue.branchId === -1),
    details: !String(details ?? "").trim(),
  };

  comboBoxesInfo.forEach(({ key, condition }) => {
    errors[key] = list.includes(key) && Boolean(condition);
  });

  return errors;
};
